<template>
  <div class='upload-user-avatar-main' :style="iosOrAndroidStyle">
    <div class="title">照片裁剪</div>

    <div class="main">
      <vueCropper style="background: transparent;" ref="cropper" :img="option.img"
        :canMove="option.canMove"
        :autoCrop="option.autoCrop"
        :centerBox="option.centerBox"
        :fixed="option.fixed"
        :fixedNumber="option.fixedNumber"></vueCropper>
    </div>

    <div class="btn">
      <div class="button" @click="leftBtnClick">取消</div>
      <div class="button active" @click="submit">完成</div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { componentsMixin } from '../../assets/js/mixin/components'
import { envMixin } from '@/assets/js/mixin/global'
import WNavbar from "@/components/global/w-navbar";
import Cookies from "js-cookie";
import {uuid} from "vue-uuid";
import {blobToFile, dataURLtoBlob} from "../../assets/js/utils";
var { VueCropper } = require('vue-cropper')

const oss = require('ali-oss')
const option = {
  img: '',
  canMove: true,
  autoCrop: true,
  centerBox: true,
  fixed: true,
  // fixedNumber: [80, 96]
  fixedNumber: [80, 80]
}
export default {
  mixins: [ componentsMixin, envMixin ],
  components: {
    WNavbar,
    VueCropper
  },
  data() {
    return {
      option,
      ossConfig: {}
    };
  },
  computed: {
    ...mapState('user', ['upFile'])
  },
  created() {
    if (!this.upFile) this.leftBtnClick();

  },
  mounted() {
    const reader = new FileReader()
    reader.readAsDataURL(this.upFile)
    reader.onload = e => {
      this.option.img = e.currentTarget.result
    }
    this.getOssConfig()
  },
  methods: {
    leftBtnClick() {
      this.$router.back();
    },
    // 初始化oss参数
    async getOssConfig () {
      let res = await this.$api.cv.getOssConfig({})
      if (res.code === 1000) {
        let { access_key_id, access_key_secret, expiration, request_id, security_token, bucket_name } = res.data
        this.ossConfig = {
          region: 'oss-cn-beijing',
          accessKeyId: access_key_id,
          accessKeySecret: access_key_secret,
          bucket: bucket_name,
          stsToken: security_token
        }
      }
    },
    submit() {
      this.$refs.cropper.getCropData(async file => {
        let store = await oss(this.ossConfig)
        let avatar = `${ uuid.v1() }-avatar`
        let blob = dataURLtoBlob(file)
        let fileData = blobToFile(blob, avatar)
        try {
          let res = await store.put(`cv/avatars/${ avatar }`, fileData)
          if (res.res.statusCode !== 200) {
            this.showToast('上传失败')
            return
          }
          let { url } = res
          let _t = Cookies.get("_t");
          let tokenPayload = JSON.parse(window.atob(_t.split(".")[1]));
          let res1 = await this.$api.user.submitUserAvatar({cv_account_token: tokenPayload.User.c_t, avatar_url: url});
          if (res1.code === 1000) {
            this.showToast('头像更新成功');
            setTimeout(() => {
              this.leftBtnClick();
            }, 1000);
          } else {
            this.showToast('头像更新失败');
          }
        } catch (e) {
          console.log(e)
        }
      })
    }
  },
}
</script>
<style lang="scss" scoped>
.upload-user-avatar-main {
  width: 100vw;
  height: 100vh;
  background: #101010;
  overflow: hidden;
  position: relative;
  .title {
    color: #fff;
    font-size: 18px;
    text-align: center;
    margin-top: 13px;
  }
  .main {
    width: 100%;
    height: 100%;
    max-width: calc(100% - 0px);
    max-height: calc(100% - 54px - 50px);
    // background: #fff;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  .btn {
    width: 100%;
    height: 54px;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 36px;
    .button {
      color: #FFFFFF;
      font-size: 16px;
      &.active {
        color: #FF4F4C;
      }
    }
  }
}
</style>
<style lang="scss">
.upload-user-avatar-main {
  .cropper-modal {
    background: transparent;
  }
}
</style>
